import React from 'react';
import DataList from '../DataList';

const EmployeeServiceAccruals = ({ employee }) => {
  const apiConfig = {
    title: 'End of service',
    path: '/employee-benefits',
    fetchEndpoint: `/hospital-portal/api/employees/leave/service-accruals?employee_id=${encodeURIComponent(employee.employee_id)}`,
    useLocalCaching: false,
    allowAdd: false,
    allowEdit: false,
    allowExport: false,
    defaultSortFieldId: 'anniversary_date',
    defaultSortAsc: false,
    fields: [
      { name: 'accrual_id', label: 'Accrual', type: 'text', identifier: true, disabled: true, visible: false },
      { name: 'anniversary_date', label: 'Anniversary', type: 'date', disabled: true },
      { name: 'completed_years', label: 'Years worked', type: 'number', disabled: true },
      { name: 'entitled_days', label: 'Days', type: 'number', disabled: true },
      { name: 'amount', label: 'Amount', type: 'number', disabled: true },
    ],
  };

  const columns = [
    { name: 'ID', selector: (row) => row.accrual_id, identifier: true, omit: true },
    {
      id: 'anniversary_date',
      name: 'Anniversary',
      selector: (row) => row.anniversary_date,
      sortable: true,
      type: 'date',
    },
    { name: 'Years worked', selector: (row) => row.completed_years, sortable: true },
    { name: 'Days', selector: (row) => row.entitled_days, sortable: true },
    { name: 'Amount', selector: (row) => row.amount, sortable: true, right: true },
  ];

  return <DataList apiConfig={apiConfig} columns={columns} />;
};

export default EmployeeServiceAccruals;
